"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceResponseModelSafetyControl = void 0;
exports.VoiceResponseModelSafetyControl = {
    None: "NONE",
    Ban: "BAN",
    Captcha: "CAPTCHA",
    CaptchaAndModeration: "CAPTCHA_AND_MODERATION",
    EnterpriseBan: "ENTERPRISE_BAN",
    EnterpriseCaptcha: "ENTERPRISE_CAPTCHA",
};
